module.exports = __webpack_public_path__ + "media/images/athletes/2116-340f09b48b4e1cdce65f21b3c08b9755.png";